// eslint-disable-next-line @typescript-eslint/no-explicit-any
type I18n = any
type FileStore = ReturnType<typeof useFileStore>

export function useDownloadFile(createSnackbar: (snackbar: Snackbar) => Snackbar, $i18n: I18n, fileStore: FileStore) {
  return async (fileId: string, fileName: string, organizationName?: string) => {
    const notification = createSnackbar({
      title: $i18n.t("downloading", { file: fileName }),
      type: "info",
      timeout: -1,
    })

    try {
      const url = await fileStore.getFileUrl(fileId)
      useDownloadUrl(url, fileName, true, organizationName)

      notification.type = "success"
      notification.title = $i18n.t("downloadSuccess", [fileName])
      notification.timeout = 3000
      notification.closable = true
    } catch {
      notification.type = "error"
      notification.title = $i18n.t("downloadFailed", [fileName])
      notification.timeout = 3000
      notification.closable = true
    }
  }
}
